import { jsx as _jsx } from "react/jsx-runtime";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Root } from '../styles';
const SwitchInput = (props) => {
    const { id, caption, value, size = 'small', disabled = false, onChange = undefined } = props;
    const onValueChange = (e) => {
        if (onChange) {
            const val = e?.target?.checked;
            if (Number.isInteger(value)) {
                onChange(val ? 1 : 0);
            }
            else {
                onChange(val);
            }
        }
    };
    return (_jsx(Root, { size: size, style: { margin: '0 5px' }, children: _jsx(FormControlLabel, { control: _jsx(Switch, { checked: !!value, onChange: onValueChange, name: id, color: "primary", disabled: disabled }), label: caption }) }));
};
export default SwitchInput;
//# sourceMappingURL=SwitchInput.js.map